module.exports = __webpack_public_path__ + "media/fastweb_volunteers/dosomething_300x250-c9a47b62.png";